/**
 * Re-déclenche les widgets tiers et scripts custom quand l'aperçu rapide
 * (quick view) injecte du contenu produit via replaceChildren() dans un modal.
 *
 * - Avis Garantis (note / étoiles) : window.reloadGRCDynamicWidgets('all')
 * - Comparateur (checkboxes "Comparer") : window.productComparison.updateCheckboxes()
 *
 * Le radar / graphique du bloc comparator s'auto-initialise via son propre
 * script inline (voir snippets/product-comparator.liquid).
 */
(function() {
	'use strict';

	var rebindTimer = null;

	function rebindQuickViewContent() {
		if (typeof window.reloadGRCDynamicWidgets === 'function') {
			try {
				window.reloadGRCDynamicWidgets('all');
			} catch (e) {
				console.warn('[quick-view-rebind] GRC reload failed', e);
			}
		}

		if (window.productComparison && typeof window.productComparison.updateCheckboxes === 'function') {
			try {
				window.productComparison.updateCheckboxes();
			} catch (e) {
				console.warn('[quick-view-rebind] updateCheckboxes failed', e);
			}
		}
	}

	function containsQuickViewContent(node) {
		if (!(node instanceof Element)) return false;
		if (node.matches && node.matches('[data-section-type="product-quick-view"]')) return true;
		if (node.querySelector && node.querySelector('[data-section-type="product-quick-view"]')) return true;
		return false;
	}

	function onMutations(mutations) {
		for (var i = 0; i < mutations.length; i++) {
			var added = mutations[i].addedNodes;
			for (var j = 0; j < added.length; j++) {
				if (containsQuickViewContent(added[j])) {
					// Debounce : plusieurs inserts successifs → un seul rebind.
					if (rebindTimer) clearTimeout(rebindTimer);
					rebindTimer = setTimeout(rebindQuickViewContent, 50);
					return;
				}
			}
		}
	}

	function start() {
		var observer = new MutationObserver(onMutations);
		observer.observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
